// Dictionary registry + public surface for the marketing i18n system.

import { en, type MktDict } from './dictionaries/en'
import { ko } from './dictionaries/ko'
import { ja } from './dictionaries/ja'
import { zh } from './dictionaries/zh'
import { zhTW } from './dictionaries/zh-TW'
import { DEFAULT_LOCALE, type LocaleCode } from './locales'

export type { MktDict } from './dictionaries/en'
export { useLocale } from './use-locale'
export {
  SUPPORTED_LOCALES,
  DEFAULT_LOCALE,
  type LocaleCode,
  type LocaleMeta,
} from './locales'

// To register a new language: add `<code>: <dict>` here (see locales.ts header).
export const DICTIONARIES: Record<LocaleCode, MktDict> = { en, ko, ja, zh, 'zh-TW': zhTW }

/** Returns the dictionary for `locale`, falling back to the default locale. */
export function getDict(locale: LocaleCode): MktDict {
  return DICTIONARIES[locale] ?? DICTIONARIES[DEFAULT_LOCALE]
}
